import api from './api';

type Section = Awaited<
  ReturnType<typeof api.calculateBeforeClaimSubmission>
>['credits']['sections'][number];

export const extractSectionSummaryValue = (
  type: Section['type'],
  sections: Section[],
) => {
  const section = sections.find((s) => s.type === type);
  return section ? section.amount : 0;
};

export const extractSectionSummaryLabel = (
  type: Section['type'],
  sections: Section[],
) => {
  const section = sections.find((s) => s.type === type);
  return section ? section.label : '';
};
